export default __webpack_public_path__ + "fonts/epilogue/Epilogue-MediumItalic.eot";